import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { useMemo } from 'react';

import { IDetailedPromotion } from 'hooks/ProgramPromotion/useProgramPromotion';

const CLOVER_DEFAULT_PHONENUMBER = '+18442911950';

export const useResellerTemplate = (phoneNumber?: string, programPromotion?: IDetailedPromotion) => {
  const hasPromotion = !!programPromotion;

  const resellerPhoneInfo = useMemo(() => {
    const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber || CLOVER_DEFAULT_PHONENUMBER);
    if (!parsedPhoneNumber) return;

    return {
      phoneNumber: `[${parsedPhoneNumber.formatNational()}](${parsedPhoneNumber.getURI()})`,
      phoneNumberLink: { url: parsedPhoneNumber.getURI(), linkText: parsedPhoneNumber.formatNational() },
    };
  }, [phoneNumber]);

  return {
    promotion: {
      isFromUrl: hasPromotion,
    },
    hasPromotion,
    resellerPhoneInfo,
  };
};

export type ResellerPromotion = ReturnType<typeof useResellerTemplate>;
